<div class="w-full flex justify-center px-2 sm:px-0">
    <div class="w-full backdrop-blur-[81.54845428466797px] bg-white/10 rounded-[36px] z-10 max-w-[1050px] py-6 sm:py-[114px]">
        <ng-content></ng-content>
    </div>
</div>